import * as types from '../actions/types';

const initialState = {
  configurations: [],
  filteredConfigurations: [],
  currentConfiguration: null,
  loading: false,
  error: null,
  categories: [],
  bulkOperationInProgress: false,
  bulkOperationStatus: null,
  searchTerm: '',
};

const aiAssistConfigReducer = (state, action) => {
  // Handle default state
  if (state === undefined) {
    state = initialState;
  }

  switch (action.type) {
    case types.GET_CONFIGS_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.GET_CONFIGS_SUCCESS:
      return {
        ...state,
        loading: false,
        configurations: Array.isArray(action.configurations) ? action.configurations : [],
        filteredConfigurations: Array.isArray(action.configurations) ? action.configurations : [],
        error: null,
      };

    case types.GET_CONFIGS_FAIL:
      return {
        ...state,
        loading: false,
        configurations: [],
        filteredConfigurations: [],
        error: action.error || 'Failed to fetch configurations',
      };

    case types.GET_CATEGORIES_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: Array.isArray(action.categories) ? action.categories : [],
        error: null,
      };

    case types.GET_CATEGORIES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error || 'Failed to fetch categories',
      };

    case types.ADD_CONFIG_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.ADD_CONFIG_SUCCESS: {
      const newConfiguration = action.configuration;
      const updatedConfigurations = [...state.configurations, newConfiguration];
      const filteredConfigurations = state.searchTerm
        ? state.filteredConfigurations.concat([newConfiguration]).filter((config) => (config.user_message || config.UserMessage || '').toLowerCase().includes(state.searchTerm.toLowerCase()) || (config.response || config.Response || '').toLowerCase().includes(state.searchTerm.toLowerCase()))
        : updatedConfigurations;

      return {
        ...state,
        loading: false,
        configurations: updatedConfigurations,
        filteredConfigurations,
        error: null,
      };
    }

    case types.ADD_CONFIG_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error || 'Failed to add configuration',
      };

    case types.BULK_ADD_START:
      return {
        ...state,
        bulkOperationInProgress: true,
        bulkOperationStatus: action.status || 'Adding configurations...',
        error: null,
      };

    case types.BULK_ADD_PROGRESS:
      return {
        ...state,
        bulkOperationStatus: action.status,
      };

    case types.BULK_ADD_SUCCESS:
      return {
        ...state,
        bulkOperationInProgress: false,
        bulkOperationStatus: null,
        error: null,
      };

    case types.BULK_ADD_FAIL:
      return {
        ...state,
        bulkOperationInProgress: false,
        bulkOperationStatus: null,
        error: action.error || 'Bulk add operation failed',
      };

    case types.UPDATE_CONFIG_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.UPDATE_CONFIG_SUCCESS: {
      const updatedConfig = action.configuration;
      const updatedConfigsList = state.configurations.map((config) => (config.id === updatedConfig.id ? updatedConfig : config));
      const updatedFilteredList = state.filteredConfigurations.map((config) => (config.id === updatedConfig.id ? updatedConfig : config));

      return {
        ...state,
        loading: false,
        configurations: updatedConfigsList,
        filteredConfigurations: updatedFilteredList,
        currentConfiguration: null,
        error: null,
      };
    }

    case types.UPDATE_CONFIG_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error || 'Failed to update configuration',
      };

    case types.DELETE_CONFIG_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.DELETE_CONFIG_SUCCESS: {
      const configIdToDelete = action.id;

      return {
        ...state,
        loading: false,
        configurations: state.configurations.filter((config) => config.id !== configIdToDelete),
        filteredConfigurations: state.filteredConfigurations.filter((config) => config.id !== configIdToDelete),
        currentConfiguration: state.currentConfiguration?.id === configIdToDelete ? null : state.currentConfiguration,
        error: null,
      };
    }

    case types.DELETE_CONFIG_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error || 'Failed to delete configuration',
      };

    case types.SEARCH_CONFIGS_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.SEARCH_CONFIGS_SUCCESS:
      return {
        ...state,
        loading: false,
        filteredConfigurations: Array.isArray(action.configurations) ? action.configurations : [],
        searchTerm: action.searchTerm || '',
        error: null,
      };

    case types.SEARCH_CONFIGS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error || 'Search failed',
      };

    case types.CLEAR_CONFIGS_SEARCH:
      return {
        ...state,
        filteredConfigurations: state.configurations,
        searchTerm: '',
        error: null,
      };

    case types.SELECT_CONFIG:
      return {
        ...state,
        currentConfiguration: action.configuration,
      };

    case types.CLEAR_ERROR:
      return {
        ...state,
        error: null,
      };

    case types.RESET_STATE:
      return {
        ...initialState,
      };

    case types.SET_LOADING:
      return {
        ...state,
        loading: action.loading,
      };

    case types.BULK_DELETE_START:
      return {
        ...state,
        bulkOperationInProgress: true,
        bulkOperationStatus: 'Deleting configurations...',
        error: null,
      };

    case types.BULK_DELETE_SUCCESS: {
      const deletedIds = action.deletedIds || [];

      return {
        ...state,
        bulkOperationInProgress: false,
        bulkOperationStatus: null,
        configurations: state.configurations.filter((config) => !deletedIds.includes(config.id)),
        filteredConfigurations: state.filteredConfigurations.filter((config) => !deletedIds.includes(config.id)),
        currentConfiguration: deletedIds.includes(state.currentConfiguration?.id) ? null : state.currentConfiguration,
        error: null,
      };
    }

    case types.BULK_DELETE_FAIL:
      return {
        ...state,
        bulkOperationInProgress: false,
        bulkOperationStatus: null,
        error: action.error || 'Bulk delete operation failed',
      };

    default:
      return state;
  }
};

export default aiAssistConfigReducer;
